import moment from 'moment-timezone';

// Options for the `formatTimestamp()`
export const FORMAT = {
  DATE_LONG: 'MMMM D, YYYY',                                     // February 23, 2019
  DATE_NUMERIC: 'MM-DD-YYYY',                                    // 03-25-2015
  DATE_SHORT: 'MMM D, YYYY',                                    // Feb 23, 2019
  DATE_SHORT_WITH_TIME: 'MMM D, YYYY [at] h:mm a',               // Feb 23, 2019 at 4:40 pm
  DATE_FULL_NUMERIC: 'YYYY-MM-DD HH:mm:ss',                      // 2019-04-24 21:42:31
  HUMAN_READABLE: 'DD-MMM-YYYY h:mm a',                          // 01-Mar-2015 3:20pm
  HUMAN_READABLE_WITH_UTC_OFFSET: 'DD-MMM-YYYY h:mm a [UTC]Z',   // 24-Apr-2019 4:34 pm UTC-07:00
  MONTH_AND_DAY: 'MMMM D',                                       // February 6
  MONTH_AND_YEAR: 'MMMM YYYY',                                   // December 2014
  TIME: 'h:mm a',                                                 // 12:05 am, 4:40 pm
};

export function formatTimestamp(timestamp: number, options: { timezone?: string; format?: string } = {}): string {
  const defaults = { format: FORMAT.DATE_FULL_NUMERIC };
  options = { ...defaults, ...options };
  const m = options.timezone ? moment(timestamp).tz(options.timezone) : moment(timestamp);

  return m.format(options.format);
}
